let queue = []
let subs = []
export const requestQueue = {
  addEventListener: (cb) => {
    subs.push(cb)
  },
  removeEventListener: (cb) => {
    subs = subs.filter((item) => {
      return item !== cb
    })
  },
  push: (item) => {
    queue.push(item)
    subs.forEach((cb) => {
      cb(queue)
    })
  },
  pop: (item) => {
    queue = queue.filter((i) => {
      return i !== item
    })
    subs.forEach((cb) => {
      cb(queue)
    })
  }
}
